export const odluka_neisk_GO = {
    templateId: 29.6,
    category: 3,
    templateTitle: 'Odluka o isplati naknade za neiskorišteni godišnji odmor',
    templateDescription: `<p>U slučaju prestanka ugovora o radu poslodavac je dužan radniku koji nije iskoristio godišnji odmor isplatiti naknadu umjesto korištenja godišnjeg odmora.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Radnik za svaku kalendarsku godinu ima pravo na godišnji odmor od najmanje četiri tjedna, a maloljetnik i radnik koji radi na poslovima na kojima, uz primjenu mjera zaštite zdravlja i sigurnosti na radu, nije moguće zaštititi radnika od štetnih utjecaja, u trajanju od najmanje pet tjedana. Kolektivnim ugovorom, sporazumom sklopljenim između radničkog vijeća i poslodavca, pravilnikom o radu ili ugovorom o radu može se utvrditi trajanje godišnjeg odmora dulje od najkraćeg propisanog Zakonom o radu te će se u tom slučaju primijeniti pravni izvor koji određuje duže trajanje godišnjeg odmora, sukladno načelu o primjeni najpovoljnijeg prava za radnika.</p>
    <p>Isplata naknade za godišnji odmor umjesto korištenja godišnjeg odmora je bezuvjetna obveza poslodavca prema svakom radniku koji nije iskoristio godišnji odmoru u cijelosti, u slučaju prestanka ugovora o radu,  bez obzira na razloge zbog kojih taj radnik nije iskoristio svoj godišnji odmor.  (Odluka Županijskog suda u Varaždinu br. Gžr-1624/14 od 11. lipnja 2014. i Županijskog suda u Bjelovaru br. Gž-2538/13 od 5. lipnja 2014.).    </p>
    <p>Naknada za neiskorišteni godišnji odmor određuje se razmjerno broju dana neiskorištenoga godišnjeg odmora. </p>
    <p>Ništetan je sporazum o odricanju od prava na godišnji odmor, odnosno o isplati naknade umjesto korištenja godišnjeg odmora.    </p>
    <p>Naknada za neiskorišteni godišnji odmor vezana je uz iznos plaće na koju radnik ima pravo te se isplaćuje prema visini plaće određenoj kolektivnim ugovorom, pravilnikom o radu ili ugovorom o radu, a najmanje u visini njegove prosječne mjesečne plaće u prethodna tri mjeseca (uračunavajući sva primanja u novcu i naravi koja predstavljaju naknadu za rad).    </p>
    
    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o radu, Ugovor o radu, Kolektivni ugovor i dr. </p>
  `,
  
    sides: [
        {
            prefix: 'Na temelju Zakona o radu,',
            signature: 'Za Poslodavca:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: '(u daljnjem tekstu: Poslodavac),',
        }
    ],

    headline: 'donosi sljedeću',
    title: 'ODLUKU O ISPLATI NAKNADE ZA NEISKORIŠTENI GODIŠNJI ODMOR',
    noArticleNumbers: true,
    
    articles: [
      {
          mandatory: true,
          statements: [
              {
                  title: '',
                  type: 'input',
                  mandatory: true,
                  editable: true,
                  parts: [
                      {type: 'text', content: 'Radnik'},
                      { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                      { type: "text", content: "," },
                      { type: 'text', content: 'iz',},
                      { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                      { type: 'text', content: ',' },
                      { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                      { type: "text", content: "," },
                      { type: 'text', content: 'OIB:' },
                      {type: 'input', value: '', required: true},
                      {type: 'text', content: 'prestaje radni odnos dana'},
                      { type: "input",  required: true, placeholder: "Unesite datum." },
                  ],
              },
          ],
      },
      {
        mandatory: true,
        statements: [
            {
                title: '',
                type: 'input',
                mandatory: true,
                editable: true,
                parts: [
                    {type: 'text', content: 'Radniku ima pravo na razmjerni dio godišnjeg odmora za '},
                    { type: 'input', value: '', required: true, placeholder: "Unesite godinu" },
                    { type: "text", content: "," },
                    { type: 'text', content: 'u trajanju od ',},
                    { type: 'input', value: '', required: true,  },
                    { type: 'text', content: 'dana' },
                    { type: "text", content: "," },
                    { type: 'text', content: 'no Radnik neće koristiti neiskorišteni godišnji odmor, nego će mu se isplatiti naknada za neiskorišteni godišnji odmor u iznosu od' },
                    {type: 'input', value: '', required: true},
                    {type: 'text', content: 'kn.'},
                ],
            },
        ],
    },
      
    {
      title: '------------------------------------------------------Obrazloženje------------------------------------------------------',
      mandatory: true,
      dummy: true,
      exampleContent: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "Poslodavac i radnik su dana __.__.20__. godine zaključili Sporazum o raskidu Ugovora o radu prema kojemu Radniku prestaje radni odnos dana __.__.20__. godine. \r\nRadnik sukladno Ugovoru o radu ima pravo na 4 tjedna godišnjeg odmora, a do sada je koristio __ dana godišnjeg odmora. \r\nRadniku je utvrđeno pravo na __ dana razmjernog godišnjeg odmora pa uzimajući u obzir da je Radnik iskoristio __ dana godišnjeg odmora, Radniku preostaje __ dana neiskorištenog godišnjeg odmora.\r\nNaknada za neiskorišteni godišnji odmor određuje se razmjerno broju dana neiskorištenoga godišnjeg odmora, pri čemu osnovicu za obračun predstavlja prosječna mjesečna plaća radnika u prethodna tri mjeseca.\r\nRadniku se tako utvrđuje naknada za neiskorišteni godišnji odmor u iznosu od _______ kn za neiskorišteni godišnji odmor iz 20__. godine u trajanju od __ dana.",
        }]
    },
    {
      title: "",
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "Slijedom toga, odlučeno je kako je navedeno u ovoj Odluci."
        }]
    },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
          },
          {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
              {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Dostaviti:\r\n1) Radniku\r\n2) Kadrovska služba',
                help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
              }
            ]
          },
          {
            static: true,
            mandatory: true,
            type: 4, 
            statements: [
              {
                type: 'text',
                mandatory: true,
                editable: true,
                help: 'Ako postupak dostave nije uređen kol. ug., sporazumom između radničkog vijeća i poslodavca ili pravilnikom o radu, primjenjuju se odredbe o dostavi određene parničnim postupkom. U tom slučaju, otkaz se može dostaviti prep. pošt. pošiljkom s povr. ili osobno, na radnom mjestu, no ukoliko radnik odbija primiti odluku, navedeno odbijanje može se pisano konstatirati uz potpis dva svjedoka. Otkaz se može dostaviti i putem j. bilježnika.',
                content: 'Potvrđujem primitak Odluke dana _______________ godine.\r\n\r\nPotpis Radnika: ____________________\r\n\r\n',
              },
            ]
          },
        ],
      };


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/29.6._odluka_neisk_GO.ts